@for(selection of selectionData; track selection; let last = $last;) {
  <div class="row" [class.is-last]="last">
    <div>{{selection.position}} {{selection.label}} </div>
  </div>
}
@if(totalLength > MAX_ALLOWED_SELECTIONS) {
  <div class="row maximum">+ {{totalLength - MAX_ALLOWED_SELECTIONS}}</div>
}

